import React, { useMemo } from 'react';
import { ImageInterface } from '../../types';
import { getImagePosition, setImageProperties } from './helpers';
import GatsbyImage from '../../helpers/GatsbyImage';

export const DefaultImage = ({
  imageData,
  imageDataMobile,
  imageSizes,
  imageFill = true,
  focusPoint,
  focusPointMobile,
  caption,
  loading,
  objectFit,
}: {
  imageData: ImageInterface['image'];
  imageDataMobile?: ImageInterface['mobileImage'];
  imageSizes?: ImageInterface['imageSizes'];
  imageFill?: ImageInterface['imageFill'];
  focusPoint?: ImageInterface['focusPoint'];
  focusPointMobile?: ImageInterface['mobileFocusPoint'];
  caption?: string;
  loading: 'lazy' | 'eager';
  objectFit?: 'cover' | 'contain';
}) => {
  const image = useMemo(() => {
    const { data, mobileMediaQuery, mobileImageRatio } = setImageProperties({
      imageData,
      imageDataMobile,
      focusPoint,
      focusPointMobile,
      imageSizes,
      imageFill,
    });

    return data ? (
      <GatsbyImage
        image={data}
        alt={caption || 'image'}
        objectFit={objectFit || 'cover'}
        objectPosition={getImagePosition(focusPoint)}
        loading={loading}
        mobileProps={
          mobileImageRatio
            ? { ratio: mobileImageRatio, mediaQuery: mobileMediaQuery }
            : undefined
        }
      />
    ) : null;
  }, [
    imageData,
    imageDataMobile,
    focusPoint,
    focusPointMobile,
    imageSizes,
    imageFill,
    caption,
    loading,
    objectFit,
  ]);

  return image;
};

export const CustomImage = ({
  url,
  caption,
  focusPoint,
  loading,
}: {
  url: string;
  caption?: string;
  focusPoint?: ImageInterface['focusPoint'];
  loading: 'lazy' | 'eager';
}) => (
  <div className="gatsby-image-wrapper">
    <picture>
      <img
        src={url}
        alt={caption || 'image'}
        style={{
          position: 'relative',
          objectFit: 'cover',
          objectPosition: getImagePosition(focusPoint),
        }}
        loading={loading}
      />
    </picture>
  </div>
);
